import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useTonAddress } from '@tonconnect/ui-react';
import { api } from '../lib/api';

export function useSavedSearches() {
  const address = useTonAddress();
  const queryClient = useQueryClient();
  const queryKey = ['savedSearches', address];

  const { data: searches = [], isLoading, error } = useQuery({
    queryKey,
    queryFn: () => api.getSavedSearches(address),
    enabled: !!address,
    staleTime: 60_000,
  });

  const createMutation = useMutation({
    mutationFn: (body: { name: string; queryParams: Record<string, string | undefined>; notifyEnabled: boolean }) =>
      api.createSavedSearch(address, body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  const updateMutation = useMutation({
    mutationFn: ({ searchId, ...body }: { searchId: number; name?: string; notifyEnabled?: boolean }) =>
      api.updateSavedSearch(address, searchId, body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  const deleteMutation = useMutation({
    mutationFn: (searchId: number) => api.deleteSavedSearch(address, searchId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  return {
    searches,
    isLoading,
    error,
    create: createMutation.mutateAsync,
    update: updateMutation.mutateAsync,
    remove: deleteMutation.mutateAsync,
    isCreating: createMutation.isPending,
  };
}
